import PropTypes from 'prop-types';
import React from 'react';

import Container from 'components/Grid/Container';
import TertiaryHeading from 'components/Headings/TertiaryHeading';
import { largeUp } from 'constants/mediaQueries';
import Theme from 'styles/theme';

import Item from './Item';

const Faq = ({ title, items }) => {
  if (!items || items.length === 0) return null;

  return (
    <Container>
      <section className="Faq">
        {title && <TertiaryHeading className="Faq__heading">{title}</TertiaryHeading>}

        <ul className="Faq__list">
          {items?.map(item => {
            return <Item {...item} key={`faq-item-${item.question}`} />;
          })}
        </ul>

        <style jsx global>
          {`
            .Faq {
              padding: ${Theme.get('spacing') * 5}px 0;
              margin: auto;
            }

            .Faq .Faq__heading {
              margin-bottom: ${Theme.get('spacing') * 2}px;
              letter-spacing: initial;
            }

            @media ${largeUp} {
              .Faq {
                padding: ${Theme.get('spacing') * 9}px 0;
              }

              .Faq .Faq__heading {
                font-size: ${Theme.get('font-size-larger-px')};
                margin-bottom: ${Theme.get('spacing') * 2.5}px;
              }
            }
          `}
        </style>
      </section>
    </Container>
  );
};

Faq.propTypes = {
  title: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      question: PropTypes.string.isRequired,
      answer: PropTypes.shape({}).isRequired,
    })
  ).isRequired,
};

export default Faq;
